/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Api_Keys_CopiedInputs */

const en_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key copied to clipboard`)
};

const fr_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clé copiée dans le presse-papiers`)
};

const de_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel in die Zwischenablage kopiert`)
};

const it_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiave copiata negli appunti`)
};

const ru_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ключ скопирован в буфер обмена`)
};

const es_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clave copiada al portapapeles`)
};

const zh_cn2_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密钥已复制到剪贴板`)
};

const ja_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーをクリップボードにコピーしました`)
};

const hi_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी क्लिपबोर्ड पर कॉपी हो गई`)
};

const pt_pt2_options_api_keys_copied = /** @type {(inputs: Options_Api_Keys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chave copiada para a área de transferência`)
};

/**
* | output |
* | --- |
* | "Key copied to clipboard" |
*
* @param {Options_Api_Keys_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_api_keys_copied = /** @type {((inputs?: Options_Api_Keys_CopiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Api_Keys_CopiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_api_keys_copied(inputs)
	if (locale === "de") return de_options_api_keys_copied(inputs)
	if (locale === "it") return it_options_api_keys_copied(inputs)
	if (locale === "ru") return ru_options_api_keys_copied(inputs)
	if (locale === "es") return es_options_api_keys_copied(inputs)
	if (locale === "zh-CN") return zh_cn2_options_api_keys_copied(inputs)
	if (locale === "ja") return ja_options_api_keys_copied(inputs)
	if (locale === "hi") return hi_options_api_keys_copied(inputs)
	if (locale === "pt-PT") return pt_pt2_options_api_keys_copied(inputs)
	return en_options_api_keys_copied(inputs)
});